export default "__VITE_ASSET__a62d15ae__"